import { useState } from 'react';
import {
  AssetCard,
  Button,
  CompatibilityBadge,
  ConfirmationDialog,
  FilterChip,
  JobProgress,
  LicenseSummary,
  PriceAndRights,
  SearchField,
  StatePanel,
} from '@3dspinit/ui';

export function DesignSystemPage() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [chipOn, setChipOn] = useState(true);

  return (
    <main className="page">
      <h1 style={{ fontFamily: 'var(--font-display)' }}>Component specimen</h1>
      <p className="muted">Core 3DSpin components — default, loading, empty, error and focus states.</p>

      <section style={{ marginTop: '2rem' }}>
        <h2 className="section-title">SearchField</h2>
        <SearchField placeholder="Search guitars, clothing…" defaultValue="museum guitar" />
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2 className="section-title">Buttons</h2>
        <div className="row">
          <Button variant="primary">Primary</Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="danger">Danger</Button>
          <Button disabled title="Sign in required">Disabled</Button>
        </div>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2 className="section-title">FilterChip</h2>
        <FilterChip selected={chipOn} onClick={() => setChipOn((v) => !v)}>
          Free
        </FilterChip>
        <FilterChip selected={!chipOn}>Paid</FilterChip>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2 className="section-title">PriceAndRights</h2>
        <PriceAndRights priceLabel="$12.00" licenseLabel="Controlled use · display" />
        <div style={{ marginTop: '0.75rem' }}>
          <PriceAndRights licenseLabel="Free controlled use" trialLabel="Trial available" />
        </div>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2 className="section-title">CompatibilityBadge</h2>
        <div className="row">
          <CompatibilityBadge status="untested" />
          <CompatibilityBadge status="passed" destination="Sansar" />
          <CompatibilityBadge status="stale" />
        </div>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2 className="section-title">AssetCard</h2>
        <div style={{ maxWidth: 280 }}>
          <AssetCard
            item={{
              id: '1',
              title: 'Very long object title that should wrap cleanly without clipping essential metadata',
              creatorName: '@creator',
              priceLabel: null,
              compatibility: 'untested',
            }}
            href="#"
          />
        </div>
        <div style={{ maxWidth: 280, marginTop: '1rem' }}>
          <AssetCard
            item={{
              id: '2',
              title: 'Missing poster fixture',
              creatorName: '@creator',
              priceLabel: '$24.00',
            }}
            href="#"
          />
        </div>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2 className="section-title">StatePanel</h2>
        <div className="card-grid">
          <StatePanel variant="loading" title="Loading" message="Fetching catalog…" />
          <StatePanel variant="empty" title="No objects match" message="Try clearing filters." actionLabel="Clear all" onAction={() => undefined} />
          <StatePanel variant="error" title="Request failed" message="Could not reach the server." />
        </div>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2 className="section-title">JobProgress & LicenseSummary</h2>
        <JobProgress stage="Converting" percent={45} message="Processing materials…" />
        <div style={{ marginTop: '1rem' }}>
          <LicenseSummary actions={['Display in room', 'Place in scene']} limitations={['No source export']} />
        </div>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <Button variant="primary" onClick={() => setDialogOpen(true)}>
          Open ConfirmationDialog
        </Button>
        <ConfirmationDialog
          open={dialogOpen}
          title="Publish paid offer"
          description="This will make a public preview visible. Buyers receive controlled-use rights, not unrestricted source export."
          confirmLabel="Publish preview"
          onConfirm={() => setDialogOpen(false)}
          onCancel={() => setDialogOpen(false)}
        />
      </section>
    </main>
  );
}
